// extracted by mini-css-extract-plugin
export default {"contact-form":"ContactForm_contact-form__zx2lN","form-control":"ContactForm_form-control__08nK6","submit-btn":"ContactForm_submit-btn__Gwsq4"};